import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { AuthStore } from '../../@ngrx/auth/auth.reducer';
import { UserActivityEndpointBase } from 'projects/shared/src/lib/components/user-activity/ua-extras/user-activity.model';

@Injectable()
export class AuthenticationInterceptorService implements HttpInterceptor {
  protected store = inject(Store);
  protected actions = inject(Actions);
  authObj = this.store.selectSignal(AuthStore.Selectors.authObj);
  token = this.store.selectSignal(AuthStore.Selectors.token);
  isLoggedIn = this.store.selectSignal(AuthStore.Selectors.isLoggedIn);
  user = this.store.selectSignal(AuthStore.Selectors.user);
  candidate = this.store.selectSignal(AuthStore.Selectors.candidate);

  constructor(public router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (environment.authenticate && this.isProtectedRequest(req.url)) {
      const token = this.token();
      return next
        .handle(
          req.clone({
            url: req.url,
            headers: req.headers
              // .set('Content-Type', `application/json`)
              .set('Authorization', `${token}`),
            withCredentials:
              // environment.useAuthCookies &&
              req.method?.toUpperCase() != 'DELETE' && req.method?.toUpperCase() != 'PUT',
          }),
        )
        .pipe(
          catchError((e) => {
            // if (e instanceof HttpErrorResponse && e.status == 401) {
            if (token && e instanceof HttpErrorResponse && e.status == 401) {
              // console.error(`About to be loggeed out due to 401 `, e, req);
              if (!this.router.url.includes(UserActivityEndpointBase)) {
                this.store.dispatch(AuthStore.actions.clearSession());
                localStorage.clear();
                sessionStorage.clear();
                void this.router.navigateByUrl('/auth/login', { replaceUrl: true });
              }
            }
            throw e;
          }),
        );
    } else return next.handle(req);
  }

  private isProtectedRequest(url: string) {
    return [
      environment.apiBaseUrl,
      environment.apiWorkflowBaseUrl,
      environment.apiMessagingBaseUrl,
      environment.apiPolicyBaseUrl,
      environment.apiGatewayBaseUrl,
      environment.apiUserServiceBaseUrl,
    ]
      .flatMap((baseUrl) => this.protectedUrlVariants(baseUrl))
      .some((baseUrl) => this.matchesBaseUrl(url, baseUrl));
  }

  private protectedUrlVariants(baseUrl?: string) {
    if (!baseUrl?.trim()) return [];

    const normalizedBaseUrl = this.withTrailingSlash(baseUrl.trim());
    const serviceRootUrl = normalizedBaseUrl.replace(/\/api\/$/, '/');

    return Array.from(new Set([normalizedBaseUrl, serviceRootUrl]));
  }

  private matchesBaseUrl(url: string, baseUrl: string) {
    const normalizedBaseUrl = this.withTrailingSlash(baseUrl);

    return url === this.withoutTrailingSlash(normalizedBaseUrl) || url.startsWith(normalizedBaseUrl);
  }

  private withTrailingSlash(value: string) {
    return value.endsWith('/') ? value : `${value}/`;
  }

  private withoutTrailingSlash(value: string) {
    return value.replace(/\/+$/, '');
  }
}
